import { Outlet } from 'react-router-dom';
import { ProgramProvider } from '../../context/ProgramContext';
import ContextSelector from './ContextSelector';
import BottomNav from './BottomNav';

function AppLayout() {
  return (
    <ProgramProvider>
      <div className="min-h-screen min-h-[100dvh] bg-transparent flex flex-col safe-area-bottom relative overflow-hidden">
        <div className="pointer-events-none absolute -top-32 -left-24 w-72 h-72 rounded-full bg-brand/10 blur-3xl" />
        <div className="pointer-events-none absolute -top-24 -right-20 w-64 h-64 rounded-full bg-emerald-200/40 blur-3xl" />
        <div className="w-full max-w-[1200px] mx-auto flex flex-col relative z-10 px-2 sm:px-4 lg:px-6">
          <header className="sticky top-0 z-30 pt-[var(--safe-area-inset-top)]">
            <ContextSelector />
          </header>
          <main className="flex-1 overflow-auto overflow-x-hidden pb-20">
            <div className="w-full max-w-[980px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
        <BottomNav />
      </div>
    </ProgramProvider>
  );
}

export default AppLayout;
